const appInfo = {
    title: 'Slamsgl'
};
export default appInfo;

